module.exports = __webpack_public_path__ + "static/img/formBg.8ddc5d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/password/gapSticklogin/formBg.jpg
// module id = zN2q
// module chunks = 157